import {
  Compass,
  DollarSign,
  Folders,
  Home,
  Map,
  Sparkles,
} from 'lucide-react';

const SIDEBAR_WIDTH = 230;

const SIDEBAR_MENU_ITEMS = [
  {
    label: 'Home',
    icon: Home,
    path: '/dashboard',
    feature: 'home',
  },
  {
    label: 'Discovery',
    icon: Compass,
    path: '/dashboard/discovery',
  },
  {
    label: 'Territories',
    icon: Map,
    path: '/dashboard/territories',
    feature: 'territories',
  },
  {
    label: 'Financial Overview',
    icon: DollarSign,
    path: '/dashboard/financial-overview',
    feature: 'financials',
  },
  {
    label: 'Library',
    icon: Folders,
    path: '/dashboard/library',
    feature: 'library',
  },
  {
    label: 'Ask Aimei',
    icon: Sparkles,
    path: '/dashboard/ask-aimei',
    feature: 'aimei',
  },
];

export { SIDEBAR_MENU_ITEMS, SIDEBAR_WIDTH };
